import { AddSectionModal } from "./AddSectionModal";

import { t } from "i18n/i18n";
import { showConfirmationModal } from "mds/components/Modal";

type ShowAddSectionModalOptions = {
  defaultCourseId?: string | null;
  defaultTermId?: string | null;
  defaultTemplateId?: string | null;
  eventName?: string;
};

export const showAddSectionModal = (options: ShowAddSectionModalOptions) => {
  const { defaultCourseId, defaultTermId, defaultTemplateId, eventName } = options;

  showConfirmationModal({
    title: t("home.add_section_modal.add_section_title"),
    hideCancelConfirmButtons: true,

    children: (onClose) => (
      <AddSectionModal
        defaultCourseId={defaultCourseId}
        defaultTemplateId={defaultTemplateId}
        defaultTermId={defaultTermId}
        eventName={eventName}
        onClose={onClose}
      />
    ),
    className: "!w-[524px]",
  });
};
